import { authRoles } from 'app/auth';
import i18next from 'i18next';
import en from './i18n/en';
import hu from './i18n/hu';
import OpcDaWriterTable from './table/OpcDaWriterTable';
import OpcDaWriterEditFormForm from './editform/OpcDaWriterEditForm';

i18next.addResourceBundle('en', 'opcDaWriter', en);
i18next.addResourceBundle('hu', 'opcDaWriter', hu);

export default [
	{
		path: '/opc-da-writer/edit/:id/:tabKey?',
		component: OpcDaWriterEditFormForm,
		auth: authRoles.opcDaWriter
	},
	{
		path: '/opc-da-writer/:sessionNameParam?',
		component: OpcDaWriterTable,
		auth: authRoles.opcDaWriter
	}
];